/**
 * Disable console logs in production
 * This will prevent all console methods from outputting to the browser console
 */

export const disableConsoleInProduction = () => {
  // Only disable in production
  if (process.env.NODE_ENV === 'production') {
    const noop = () => {};
    
    // Store original console methods in case we need them
    window._originalConsole = {
      log: console.log,
      warn: console.warn,
      error: console.error,
      info: console.info,
      debug: console.debug,
      trace: console.trace,
      table: console.table,
      time: console.time,
      timeEnd: console.timeEnd,
      group: console.group,
      groupEnd: console.groupEnd,
      groupCollapsed: console.groupCollapsed,
    };

    // Override console methods with no-op functions
    console.log = noop;
    console.warn = noop;
    console.error = noop;
    console.info = noop;
    console.debug = noop;
    console.trace = noop;
    console.table = noop;
    console.time = noop;
    console.timeEnd = noop;
    console.group = noop;
    console.groupEnd = noop;
    console.groupCollapsed = noop;
  }
};

// Function to restore console if needed (for debugging)
export const restoreConsole = () => {
  if (window._originalConsole) {
    Object.keys(window._originalConsole).forEach(method => {
      console[method] = window._originalConsole[method];
    });
  }
};